import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ShopMembershipDetailByIdGQL } from './gql/shop-membership.gql.generated';
import { IShopMembershipDetail } from './types/shop-membership';

@Injectable()
export class ShopMembershipService {
  constructor(private readonly detailGQL: ShopMembershipDetailByIdGQL) {}

  fetchDetail(id: number, channelCode: string, locale: string): Observable<IShopMembershipDetail> {
    return this.detailGQL
      .fetch({ id, locale, channelCode })
      .pipe(map((r) => r.data.shopMembership));
  }
}
